import { accountsMapping } from "./accountsMapping";
import { assessmentsMapping } from "./assessmentsMapping";
import { campaignMapping } from "./campaignMapping";
import { emailsMapping } from "./emailsMapping";
import { embeddedVideosMapping } from "./embeddedVideosMapping";
import { eventsMapping } from "./eventsMapping";
import { externalLinkMapping } from "./externalLinkMapping";
import { flowMapping } from "./flowMapping";
import { messagesMapping } from "./messagesMapping";
import { packsMapping } from "./packsMapping";
import { pdfsMapping } from "./pdfsMapping";
import { peopleMapping } from "./peopleMapping";
import { surveysMapping } from "./surveysMapping";
import { templateMapping } from "./templateMapping";
import { videoAssetsMapping } from "./videoAssetsMapping";

export default function createMapping(dispatch) {
  const mapping = {};

  videoAssetsMapping(mapping, dispatch);
  peopleMapping(mapping, dispatch);
  accountsMapping(mapping, dispatch);
  emailsMapping(mapping, dispatch);
  assessmentsMapping(mapping, dispatch);
  eventsMapping(mapping, dispatch);
  flowMapping(mapping, dispatch);
  surveysMapping(mapping, dispatch);
  packsMapping(mapping, dispatch);
  campaignMapping(mapping, dispatch);
  pdfsMapping(mapping, dispatch);
  messagesMapping(mapping, dispatch);
  templateMapping(mapping, dispatch);
  embeddedVideosMapping(mapping, dispatch);
  externalLinkMapping(mapping, dispatch);
  return mapping;
}
